export const ADD_TODO = "ADD_TODO";
export const TOGGLE_TODO = "TOGGLE_TODO";
export const SET_FILTER = "SET_FITLER";
export const REMOVE_TODO = "REMOVE_TODO";
export const SEARCH_TODO = "SEARCH_TODO";